import EditIcon from "components/Icons/EditIcon";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import { IDriverWallet } from "models/driverWallet";
import { useWalletAlertContext } from "./AlertContext";
import PlusIcon from "components/Icons/PlusIcon";
import MinusIcon from "components/Icons/MinusIcon";
import ViewIcon from "components/Icons/ViewIcon";
import { isAdmin, isCasherOrSuperAdmin } from "helpers/privilege";

interface IProps {
  wallet: IDriverWallet;
}

export default function Action({ wallet }: IProps) {
  const { showAdd, showDeduct } = useWalletAlertContext();

  return (
    <div className="flex items-center gap-x-2">
      <Link
        to={RouteName.EDIT_DRIVER_WALLET.replace(":id", wallet.id)}
        className="rounded-ful hover:text-black"
      >
        <EditIcon />
      </Link>

      {isAdmin() && (
        <button onClick={() => showDeduct(wallet)}>
          <MinusIcon />
        </button>
      )}
      <Link
        className="rounded-ful hover:text-black"
        to={RouteName.DRIVER_WALLET_DETAIL.replace(":id", wallet.driver_id)}
      >
        <ViewIcon />
      </Link>
    </div>
  );
}
